import { ElementRef, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { InputFocusAbstractService } from './input-focus.abstract.service';

@Injectable({
  providedIn: 'root'
})
export class InputFocusService implements InputFocusAbstractService {

  private _totalInputsBuilt = 0;
  public inputsOnDom$ = new BehaviorSubject<number>(this._totalInputsBuilt);
  public agentInputsOnDom$ = new BehaviorSubject<number>(this._totalInputsBuilt);

  /**
   * @description to add input in dom list
   * @param
   * @returns
   */
  private addInputToDom(): void {
    this._totalInputsBuilt++;
    this.inputsOnDom$.next(this._totalInputsBuilt);
  }

  /**
   * @description to add business info input in dom list
   * @param
   * @returns
   */
  public addAgentInputToDom(): void {
    this._totalInputsBuilt++;
    this.agentInputsOnDom$.next(this._totalInputsBuilt);
  }

  /**
   * @description to reset dom list
   * @param
   * @returns
   */
  public resetTotalInputsBuilt(): void {
    this._totalInputsBuilt = 0;
    this.inputsOnDom$.next(this._totalInputsBuilt);
    this.agentInputsOnDom$.next(this._totalInputsBuilt);
  }

  /**
   * @description to emit to set new input to be added in dom
   * @param el : ElementRef
   * @returns
   */
  public emitInputIsSet(): void {
    // Elements are not exactly in the dom on AfterViewInit
    setTimeout(() => {
      this.addInputToDom();
    });
  }

  /**
   * @description to emit to set new business info input to be added in dom
   * @param el : ElementRef
   * @returns
   */
  public emitAgentInputIsSet(el?: ElementRef<any>): void {
    if (el) {
      // Elements are not exactly in the dom on AfterViewInit
      setTimeout(() => {
        this.addAgentInputToDom();
      });
    }
  }

}
